export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/clothing.7382815.svg";